import { useConfirmIdentificationStep } from './useConfirmIdentificationStep'
import { ConfirmIdentificationStepUI } from './ConfirmIdentificationStepUI'

export const ConfirmIdentificationStep = () => {
  const props = useConfirmIdentificationStep()

  return <ConfirmIdentificationStepUI {...props} />
}
